import React from "react";

export default function BillingMismatchBanner({ planName, amountMinor, currency }) {
  const code = String(currency).toUpperCase();
  const body =
    amountMinor == null ? (
      <>
        You're currently billed <strong>{planName}</strong> in <strong>{currency}</strong>.
        Changing country does not change this charge.
      </>
    ) : (
      <>
        You're currently billed{" "}
        <strong>
          {planName} — {amountMinor / 100} {code} / month
        </strong>
        . Changing billing country does not change this charge. The new currency
        applies only if you switch plan.
      </>
    );

  return (
    <p
      className="rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-sm text-[#F3F4F6]"
      data-testid="billing-mismatch-banner"
      role="status"
    >
      {body}
    </p>
  );
}
